import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, TextArea, SubmitBtn } from "../../Components/InputElements";
import axios from 'axios';

import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select'
import { decodeData } from '../../Constants/constants';

class SalrayStatutory extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            company_salary_statutory_id: 0,
            company_salary_statutory_title: '',
            company_salary_statutory_description: '',
            company_salary_statutory_employee_contribution: '',
            company_salary_statutory_employer_contribution: '',
            company_salary_statutory_calculate_upto: '',
            rows: [],
            errors: {},
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            salary_heads_rows: [],
            company_salary_statutory_ids: '',
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetSalaryHeadsList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }

    handleInputChange = (e) => {
        const { name, value } = e.target;


        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    handleSelect = (e) => {
        var ids = [];
        for (var i = 0; i < e.length; i++) {
            ids.push(e[i].value);
        }
        this.setState({
            company_salary_statutory_ids: ids.join(','),
            errors: {
                ...this.state.errors,
                company_salary_statutory_ids: '',
            }
        });
    }
    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetSalaryStatutoryInfo?company_salary_statutory_id=${this.state.company_salary_statutory_id}`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        company_salary_statutory_title: data[0].company_salary_statutory_title,
                        company_salary_statutory_description: data[0].company_salary_statutory_description,
                        company_salary_statutory_employee_contribution: data[0].company_salary_statutory_employee_contribution,
                        company_salary_statutory_employer_contribution: data[0].company_salary_statutory_employer_contribution,
                        company_salary_statutory_calculate_upto: data[0].company_salary_statutory_calculate_upto,
                        company_salary_statutory_ids: data[0].company_salary_statutory_ids,

                    }
                )
            }
        });
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetSalaryStatutorys`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {

            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetSalaryHeadsList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetSalaryHeads`, { params: { limit: 1000, page: this.state.page }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        salary_heads_rows: data.data.map((row) => ({
                            value: row.company_salary_head_id,
                            label: row.company_salary_head
                        }))
                    }));
                }
            });
    }


    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {

            company_salary_statutory_title: this.state.company_salary_statutory_title,
            company_salary_statutory_description: this.state.company_salary_statutory_description,
            company_salary_statutory_employee_contribution: this.state.company_salary_statutory_employee_contribution,
            company_salary_statutory_employer_contribution: this.state.company_salary_statutory_employer_contribution,
            company_salary_statutory_calculate_upto: this.state.company_salary_statutory_calculate_upto,
            company_salary_statutory_ids: this.state.company_salary_statutory_ids


        }
        if (this.state.company_salary_statutory_id !== 0) {
            formData.company_salary_statutory_id = this.state.company_salary_statutory_id;
        }

        axios
            .post(`${apiURL}Masters/CreateSalaryStatutory`, formData, { headers })
            .then((response) => {

                const { success } = response.data;
                if (success === true) {
                    this.resetForm();

                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                } else {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                }

            })
    };
    resetForm = () => {
        this.setState({
            company_salary_statutory_id: 0,
            company_salary_statutory_title: '',
            company_salary_statutory_description: '',
            company_salary_statutory_employee_contribution: '',
            company_salary_statutory_employer_contribution: '',
            company_salary_statutory_calculate_upto: '',
            salary_heads_rows: [],
            company_salary_statutory_ids: '',
        })

    }
    validateForm = () => {
        const errors = {};

        if (!this.state.company_salary_statutory_title) {
            errors.company_salary_statutory_title = 'Salary statutory title is required';
        }
        if (!this.state.company_salary_statutory_description) {
            errors.company_salary_statutory_description = 'Salary statutory description is required';
        }
        if (!this.state.company_salary_statutory_employee_contribution) {
            errors.company_salary_statutory_employee_contribution = 'Employee contribution is required';
        }
        if (!this.state.company_salary_statutory_employer_contribution) {
            errors.company_salary_statutory_employer_contribution = 'Employer contribution is required';
        }
        if (!this.state.company_salary_statutory_calculate_upto) {
            errors.company_salary_statutory_calculate_upto = 'Calculate upto is required';
        }
        if (!this.state.company_salary_statutory_calculate_upto) {
            errors.company_salary_statutory_calculate_upto = 'Calculate upto is required';
        }
        if (!this.state.company_salary_statutory_ids) {
            errors.company_salary_statutory_ids = 'At least one salary head must be selected';
        }

        return errors;
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    company_salary_statutory_id: id
                };
                axios
                    .post(`${apiURL}Masters/DeleteSalaryStatutory`, formData, { headers })
                    .then((response) => {

                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }
    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Salary Statutory`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Salary Statutory</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={this.handleSubmit} className="row">
                                                    <div className="col-md-12">
                                                        <label htmlFor="company_salary_statutory_title" className="form-label">Salary Statutory Title</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.company_salary_statutory_title ? 'is-invalid' : ''}`}
                                                            id="company_salary_statutory_title"
                                                            name="company_salary_statutory_title"
                                                            value={this.state.company_salary_statutory_title}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Salary Statutory Title"
                                                        />
                                                        {errors.company_salary_statutory_title && <div className="text-danger">{errors.company_salary_statutory_title}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="company_salary_statutory_description" className="form-label">Salary Statutory Description</label>
                                                        <textarea
                                                            type="text"
                                                            className={`form-control ${errors.company_salary_statutory_description ? 'is-invalid' : ''}`}
                                                            id="company_salary_statutory_description"
                                                            name="company_salary_statutory_description"
                                                            value={this.state.company_salary_statutory_description}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Salary Statutory Description"
                                                        />
                                                        {errors.company_salary_statutory_description && <div className="text-danger">{errors.company_salary_statutory_description}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="company_salary_statutory_employee_contribution" className="form-label">Employee Contribution</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.company_salary_statutory_employee_contribution ? 'is-invalid' : ''}`}
                                                            id="company_salary_statutory_employee_contribution"
                                                            name="company_salary_statutory_employee_contribution"
                                                            value={this.state.company_salary_statutory_employee_contribution}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Employee Contribution"
                                                        />
                                                        {errors.company_salary_statutory_employee_contribution && <div className="text-danger">{errors.company_salary_statutory_employee_contribution}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="company_salary_statutory_employer_contribution" className="form-label">Employer Contribution</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.company_salary_statutory_employer_contribution ? 'is-invalid' : ''}`}
                                                            id="company_salary_statutory_employer_contribution"
                                                            name="company_salary_statutory_employer_contribution"
                                                            value={this.state.company_salary_statutory_employer_contribution}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Employer Contribution"
                                                        />
                                                        {errors.company_salary_statutory_employer_contribution && <div className="text-danger">{errors.company_salary_statutory_employer_contribution}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="company_salary_statutory_calculate_upto" className="form-label">Calculate Upto</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.company_salary_statutory_calculate_upto ? 'is-invalid' : ''}`}
                                                            id="company_salary_statutory_calculate_upto"
                                                            name="company_salary_statutory_calculate_upto"
                                                            value={this.state.company_salary_statutory_calculate_upto}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Calculate Upto"
                                                        />
                                                        {errors.company_salary_statutory_calculate_upto && <div className="text-danger">{errors.company_salary_statutory_calculate_upto}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label>Select head</label>
                                                        {/* <Select onChange={this.handleSelect} hint={`Select Statutory`} isMulti options={this.state.salary_heads_rows} value={this.state.salary_heads_rows.find(option => option.value === this.state.company_salary_statutory_ids)} /> */}
                                                        <Select
                                                            onChange={this.handleSelect}
                                                            placeholder={`Select head`}
                                                            isMulti
                                                            options={this.state.salary_heads_rows}
                                                            value={this.state.company_salary_statutory_ids.split(',').map(id => this.state.salary_heads_rows.find(option => option.value === parseInt(id)))}
                                                            name='company_salary_statutory_ids'
                                                            />
                                                            {errors.company_salary_statutory_ids && <div className="text-danger">{errors.company_salary_statutory_ids}</div>}
                                                    </div>

                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            this.state.company_salary_statutory_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />

                                                        }

                                                        {
                                                            this.state.company_salary_statutory_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />New</button> : <div></div>

                                                        }
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th width={150}>Salary Statutory Title</th>
                                                    <th>Salary Statutory Description</th>
                                                    <th>Employee Contribution</th>
                                                    <th>Employer Contribution</th>
                                                    <th>Calculate Upto</th>
                                                    <th className='text-center' width={120}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.company_salary_statutory_id}>
                                                            <td>{row.company_salary_statutory_title}</td>
                                                            <td>{row.company_salary_statutory_description}</td>
                                                            <td>{row.company_salary_statutory_employee_contribution}</td>
                                                            <td>{row.company_salary_statutory_employer_contribution}</td>
                                                            <td>{row.company_salary_statutory_calculate_upto}</td>


                                                            <td className='d-flex justify-content-around'>
                                                                <button type='button' onClick={() => this.setState({ company_salary_statutory_id: row.company_salary_statutory_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                <button onClick={() => this.handleDelete(row.company_salary_statutory_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>
                                                            </td>
                                                        </tr>
                                                    })
                                                }

                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={6} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>

                                            </tfoot>

                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(SalrayStatutory);